import { useMemo } from "react";

import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";

export const RTFOSeismicAmplitudeTable = ({currentStageName, seismicAmplitudeEvents, darkMode}) => {
  
  const columns = [
    {
      field: 'stageName',
      headerName: 'Stage Name',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'stageNumber',
      headerName: 'Stage Number',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'name',
      headerName: 'Event',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      editable: false,
      sortable: true,
      filterable: true,
      type: 'string'
    },
    {
      field: 'deltaTime',
      headerName: 'Time From Start (min)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'pressure',
      headerName: 'Pressure (MPa)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'rate',
      headerName: 'Rate (m3/min)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'proppant',
      headerName: 'Proppant Conc. (kg/m3)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'slurryVolume',
      headerName: 'Slurry Volume (m3)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    },
    {
      field: 'cumProppant',
      headerName: 'Cum. Proppant (tons)',
      width: 100,
      editable: false,
      sortable: true,
      filterable: true
    }
  ];


  const rows = useMemo(() => {
    return seismicAmplitudeEvents?.map((event,i) => {
    
      return {
        id: event?.stageName + '-' + i,
        name: event?.name,
        stageName: event?.stageName,
        stageNumber: event?.stageName?.split('_')?.[2],
        date: event?.date,
        deltaTime: Number((event?.deltaTime || 0)?.toFixed(2)),
        pressure: Number((event?.pressure || 0)?.toFixed(2)),
        rate: Number((event?.rate || 0)?.toFixed(2)),
        proppant: Number((event?.proppant || 0)?.toFixed(2)),
        slurryVolume: Number((event?.slurryVolume || 0)?.toFixed(2)),
        cumProppant: Number((event?.cumProppant || 0)?.toFixed(2))
      };
    });
  }, [seismicAmplitudeEvents]);
  
  
  return (
    <DataGrid
      density="compact"
      rows={rows}
      columns={columns}
      rowsPerPageOptions={[10,25,50,100]}
      disableSelectionOnClick
      sx={{
        '& .super-app-theme--Current': {
          fontWeight: 'bold',
          backgroundColor: 'rgba(7, 88, 183, 0.25)' // highlight the current row
        }
      }}
      components={{
        Toolbar: CustomToolbar,
      }}
      style={{fontSize: '12px'}}
      getRowClassName={(params) => {
        return (params?.row?.stageName === currentStageName) ? `super-app-theme--Current` : '';
      }}
    />
  );

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarFilterButton style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarDensitySelector style={{ color: darkMode && 'lightgrey' }} />
        <GridToolbarExport style={{ color: darkMode && 'lightgrey' }} />
      </GridToolbarContainer>
    );
  };
};